// Modules
import React from 'react';
import App from './App';
import { Route, IndexRoute } from 'react-router';
import Layout from './layout';
import ChannelContainer from 'components/channel/channel-container';
import SearchContainer from 'components/search/search-container';
import Catalog from 'components/catalog/catalog';
import NotFound from 'components/errors/notfound';
import UnsupportedBrowser from 'components/errors/unsupported-browser';
import InternalServer from 'components/errors/internalServer';
import HomePage from 'components/home-page/homePage';
import WatchNow from 'components/watch-now/watch-now';
import LearnMore from 'components/learn-more/learn-more';
import FaqPage from 'components/faq-page/faqPage';
import ComingSoon from 'components/coming-soon/coming-soon';

export default (
    <Route path="/" component={App}>
        <Route component={Layout}>
            <IndexRoute component={HomePage} />
            <Route path="/channel(/:user)(/edit)" component={ChannelContainer}>
                <IndexRoute component={Catalog} />
                <Route path="recording/:recordingKey/watch" component={WatchNow} />
            </Route>
            <Route path="/search" component={SearchContainer} />
            <Route path="/organizer/learn-more" component={LearnMore} />
            <Route path="/organizer/coming-soon" component={ComingSoon} />
            <Route path="/landingPage" component={HomePage} />
            <Route path="/faq" component={FaqPage} />
            <Route path="/internalError" component={InternalServer} />
            <Route path="/unsupportedBrowser" component={UnsupportedBrowser} />
            <Route status={404} path="*" component={NotFound} />
        </Route>
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js